// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgNofiles24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<g clipPath="url(#clip0_6830_376218)">
					<g clipPath="url(#clip1_6830_376218)">
						<path d="M21.3907 5.56124V4.17751C21.3907 4.09448 21.4 3.38417 20.8926 2.86758C20.6712 2.63696 20.2561 2.36021 19.5919 2.36021L9.80431 2.26796C9.37997 1.97277 8.84493 1.7237 8.18996 1.7237H3.95575C2.71962 1.71447 1.71411 2.71998 1.71411 3.95611V14.9245C1.71411 16.1606 2.71962 17.1661 3.95575 17.1661H6.47414C6.85236 20.0535 9.32462 22.2859 12.3042 22.2859C15.2839 22.2859 17.7561 20.0535 18.1344 17.1661H20.6527C21.8889 17.1661 22.8944 16.1606 22.8944 14.9245V7.58148C22.8944 6.85272 22.4793 5.81953 21.3907 5.56124ZM19.5919 3.73471C19.7395 3.73471 20.007 3.73471 20.007 4.14983V5.49666H13.1068C12.5994 5.49666 12.129 5.05387 12.0091 4.9155L11.0866 3.65169L19.5919 3.73471ZM12.3042 20.9022C9.82276 20.9022 7.80252 18.8819 7.80252 16.4004C7.80252 13.919 9.82276 11.8987 12.3042 11.8987C14.7857 11.8987 16.806 13.919 16.806 16.4004C16.806 18.8819 14.7857 20.9022 12.3042 20.9022ZM21.5107 14.9245C21.5107 15.3949 21.1232 15.7824 20.6527 15.7824H18.162C17.8576 12.8212 15.3484 10.5058 12.3042 10.5058C9.26004 10.5058 6.76011 12.8212 6.44646 15.7824H3.95575C3.48528 15.7824 3.09784 15.3949 3.09784 14.9245V3.95611C3.09784 3.48564 3.48528 3.0982 3.95575 3.0982H8.19919C9.0571 3.0982 9.65671 4.03913 9.69361 4.09448L10.9113 5.76418C11.0035 5.87488 11.8522 6.88962 13.1068 6.88962H20.8465C21.3723 6.88962 21.4922 7.26784 21.5014 7.58148V14.9245H21.5107Z" />
						<path d="M14.2416 14.4633C13.9741 14.1958 13.5313 14.1958 13.2637 14.4633L12.3044 15.4227L11.345 14.4633C11.0775 14.1958 10.6347 14.1958 10.3671 14.4633C10.0996 14.7309 10.0996 15.1737 10.3671 15.4412L11.3265 16.4006L10.3671 17.3599C10.0996 17.6275 10.0996 18.0703 10.3671 18.3378C10.5055 18.4762 10.6808 18.5407 10.8561 18.5407C11.0313 18.5407 11.2066 18.4762 11.345 18.3378L12.3044 17.3784L13.2637 18.3378C13.4021 18.4762 13.5774 18.5407 13.7527 18.5407C13.9279 18.5407 14.1032 18.4762 14.2416 18.3378C14.5091 18.0703 14.5091 17.6275 14.2416 17.3599L13.2822 16.4006L14.2416 15.4412C14.5091 15.1737 14.5091 14.7309 14.2416 14.4633Z" />
					</g>
				</g>
				<defs>
					<clipPath id="clip0_6830_376218">
						<rect width={21.4286} height={21.2571} transform="translate(1.28564 1.71436)" />
					</clipPath>
					<clipPath id="clip1_6830_376218">
						<rect width={21.1803} height={20.5714} transform="translate(1.71411 1.71436)" />
					</clipPath>
				</defs>
			</Svg>
		);
	}
);
SvgNofiles24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgNofiles24;
